import React from 'react';
import { Button } from './ui/Button';
import { Check, Download, ShieldCheck } from 'lucide-react';
export function PricingSection() {
  return <section id="pricing" className="bg-black py-24 px-4 border-t border-gray-900 pt-[55px] pb-[55px]" data-id="element-65">
      <div className="max-w-lg mx-auto" data-id="element-66">
        <div className="bg-[#050505] border border-gray-800 rounded-2xl p-8 md:p-12 relative overflow-hidden" data-id="element-67">
          {/* Glow effect */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1 bg-gradient-to-r from-transparent via-orange-500 to-transparent opacity-70" data-id="element-68"></div>

          <div className="text-center mb-8" data-id="element-69">
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-2" data-id="element-70">
              The Complete Feline Harmony Blueprint™
            </h2>
            <div className="h-1 w-12 bg-orange-600 mx-auto mt-4 rounded-full" data-id="element-71"></div>
          </div>

          <ul className="space-y-4 mb-10" data-id="element-72">
            {['Lifetime Access to the 7-Phase Protocol', 'Interactive Daily Integration Checklist', 'Behavioral Troubleshooting Guide'].map((item, i) => <li key={i} className="flex items-start text-gray-300" data-id="element-73">
                <Check className="w-5 h-5 text-orange-500 mr-3 shrink-0 mt-0.5" data-id="element-74" />
                <span data-id="element-75">{item}</span>
              </li>)}
          </ul>

          <div className="text-center mb-8" data-id="element-76">
            <p className="text-gray-500 text-sm mb-1" data-id="element-77">
              REGULAR PRICE: <span className="line-through" data-id="element-78">$19.99</span>
            </p>
            <div className="flex items-center justify-center gap-3" data-id="element-79">
              <span className="text-orange-500 font-bold text-sm uppercase tracking-wider bg-orange-950/30 px-2 py-1 rounded" data-id="element-80">
                Limited Time Offer
              </span>
            </div>
            <p className="text-5xl font-bold text-white mt-3" data-id="element-81">$6.39</p>
          </div>

          <Button variant="glow" size="lg" className="w-full mb-6" onClick={() => window.location.href = 'https://thinkarox.com/cart/47374599127270:1'} data-id="element-82">
            Get the Complete Blueprint
            <Download className="ml-2 w-5 h-5" data-id="element-83" />
          </Button>

          <div className="flex items-start gap-3 bg-gray-900/50 p-4 rounded-lg border border-gray-800" data-id="element-84">
            <ShieldCheck className="w-6 h-6 text-orange-500 shrink-0" data-id="element-85" />
            <div className="text-left" data-id="element-86">
              <p className="text-white font-bold text-sm mb-1" data-id="element-87">
                7-Day Peace Guarantee
              </p>
              <p className="text-xs text-gray-400" data-id="element-88">
                If your home doesn't feel more harmonious, we'll refund your
                $6.39. No questions asked.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}